var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaynowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19V1.9C1 1.66131 1.08533 1.43239 1.23721 1.2636C1.38909 1.09482 1.59509 1 1.80989 1H19.6274C19.8422 1 20.0482 1.09482 20.2001 1.2636C20.3519 1.43239 20.4373 1.66131 20.4373 1.9V19L17.1977 17.2L13.9582 19L10.7186 17.2L7.47909 19L4.23954 17.2L1 19Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4V13.75",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 6.99707C13.625 6.75084 13.5765 6.50702 13.4823 6.27954C13.388 6.05205 13.2499 5.84535 13.0758 5.67125C12.9017 5.49714 12.695 5.35902 12.4675 5.2648C12.24 5.17057 11.9962 5.12207 11.75 5.12207H10.25C9.75272 5.12207 9.27581 5.31961 8.92417 5.67125C8.57254 6.02288 8.375 6.49979 8.375 6.99707C8.375 7.49435 8.57254 7.97126 8.92417 8.3229C9.27581 8.67453 9.75272 8.87207 10.25 8.87207H12.125C12.6223 8.87207 13.0992 9.06961 13.4508 9.42124C13.8025 9.77288 14 10.2498 14 10.7471C14 11.2444 13.8025 11.7213 13.4508 12.0729C13.0992 12.4245 12.6223 12.6221 12.125 12.6221H9.875C9.37772 12.6221 8.90081 12.4245 8.54917 12.0729C8.19754 11.7213 8 11.2444 8 10.7471",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaynowIcon);
export default __webpack_public_path__ + "static/media/paynow-icon.2f4718a0ef29ddcf73ec4395af132690.svg";
export { ForwardRef as ReactComponent };